<template>
  <div class="QuotationEdit pb7" v-title data-title="生成报价单">
    <!-- 大类 -->
    <div v-show="!loading">
      <div class="fixed-tab tab-holder">
        <van-tabs v-if="quoteType" v-model="quoteType" @change="changeBigCate"
        :offset-top="0"
        sticky
        type="card"
        color="#1e67c7"
        >
          <template v-for="qt in quoteTypes">
            <van-tab
              class=""
              v-if="(crayfishLimit&&qt.name===1)||(crabLimit&&qt.name===2)"
              :key="qt.name"
              :title="qt.title" :name="qt.name"
            ></van-tab>
          </template>
        </van-tabs>
      </div>
      <div class="tab-holder"></div>
      <div class="add-box bc-default">
        <div v-if="!selectUnit.text" class="fc-danger pt5 pb5">请先选择重量单位</div>
        <div class="add bc-white fc-primary" @click="changeUnit()">
          {{selectUnit.value?'点击切换':'点击选择'}}重量单位{{selectUnit.text?'(当前选择：'+selectUnit.text+')':''}}
        </div>
      </div>
      <div class="row align-items-center pb4 fs4 small-categories pr2 text-left">
        <div class="pl3 pr3 btn-label">档口名称</div>
        <div class="col fs2 row align-items-center">
          <van-field class="flex-1"
            v-model="params.name" placeholder="档口名称" />
        </div>
      </div>
      <div v-if="templateType==1" class="row align-items-center pb4 fs4 small-categories pr2 text-left">
        <div class="pl3 pr3 btn-label">客户名称</div>
        <div class="col fs2 row align-items-center">
          <van-field class="flex-1"
            v-model="params.customer" placeholder="客户名称" />
        </div>
      </div>
      <div class="row align-items-center pb4 fs4 small-categories pr2 text-left">
        <div class="pl3 pr3 btn-label">销售日期</div>
        <div class="col fs2 row align-items-center" @click="showDateAction">
          <van-field class="flex-1"
            readonly
            v-model="params.queryDateText" placeholder="销售日期" />
        </div>
      </div>
      <div class="row align-items-center pb4 fs4 small-categories pr2 text-left">
        <div class="pl3 pr3 btn-label"><span class="fc-danger">*</span>价格类型</div>
        <div class="col fs2 row align-items-center">
          <van-field v-if="priceType.isCustom" class="flex-1"
            v-model="priceType.value" placeholder="自定义" />
          <div v-else class="flex-1 input-common"
            :class="priceType.text?'':'fc-suppl'" @click="showPriceTypePickerFunc">
            {{priceType.text || '请选择'}}
          </div>
          <a v-if="priceType.value || priceType.isCustom" @click="cancelPriceTypeCustom(priceType)"
            class="pt3 pb3 pl3 fc-danger">取消</a>
        </div>
      </div>
      <!-- <div class="row align-items-center pb4 fs4 small-categories pr2 text-left">
        <div class="pl3 pr3 btn-label"><span class="fc-danger">*</span>运费</div>
        <div class="col fs2 row align-items-center">
          <van-field v-if="freight.isCustom" class="flex-1"
            v-model="freight.value" placeholder="自定义" />
          <div v-else class="flex-1 input-common"
            :class="freight.text?'':'fc-suppl'" @click="showInfo1PickerFunc">
            {{freight.text || '请选择'}}
          </div>
          <a v-if="freight.value || freight.isCustom" @click="cancelInfo1Custom(freight)"
            class="pt3 pb3 pl3 fc-danger">取消</a>
        </div>
      </div>
      <div class="row align-items-center fs4 small-categories pr2 text-left">
        <div class="pl3 pr3 btn-label"><span class="fc-danger">*</span>死亡</div>
        <div class="col fs2 row align-items-center">
          <van-field v-if="death.isCustom" class="flex-1"
            v-model="death.value" placeholder="自定义" />
          <div v-else class="flex-1 input-common"
            :class="death.text?'':'fc-suppl'" @click="showInfo2PickerFunc">
            {{death.text || '请选择'}}
          </div>
          <a v-if="death.value || death.isCustom" @click="cancelInfo2Custom(death)"
            class="pt3 pb3 pl3 fc-danger">取消</a>
        </div>
      </div> -->
    </div>
    <!-- 报价明细 -->
    <div class="pt5"></div>
    <table class="table-quotation" >
      <thead>
        <tr style="vertical-align: top;">
          <th width="25%">行话</th>
          <th width="25%">{{mapping[quoteType].label2}}
            <div v-if="selectUnit.text" class="fs1">({{selectUnit.text||''}})</div>
          </th>
          <th width="40%">价格<div class="fs1">(元/斤)</div></th>
          <th width="50px">操作</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(sub, index) in categories" :key="index">
          <!-- 行话 -->
          <td>
            <div v-if="sub.isCustom" class="row align-items-center" >
              <van-field class="text-center flex-1 fs1"
                @input="onCateInput(sub)" right-icon="clear"
                @click-right-icon="resetCustom(sub, 'categoryText','customValue', 'isCustom')"
                v-model="sub.customValue" placeholder="自定义" />
              <!-- <a @click="cancelCustom(index)" class="fs1 pt3 pb3 pl3 fc-danger">取消</a> -->
            </div>
            <div v-else  @click="showCatePickerFunc(index)">
              {{sub.categoryText||''}}
              <span class="fc-suppl" v-if="!sub.categoryText">选择行话</span>
            </div>
          </td>
          <td>
            <!-- 规格 -->
            <div v-if="sub.weightCustom" class="row align-items-center" >
              <van-field class="text-center flex-1 fs1"
                @input="onSizeInput(sub)" right-icon="clear"
                @click-right-icon="resetCustom(sub, 'weightText','weightCode', 'weightCustom')"
                v-model="sub.weightCode" placeholder="自定义" />
              <!-- <a @click="cancelCustom(index)" class="fs1 pt3 pb3 pl3 fc-danger">取消</a> -->
            </div>
            <div v-else-if="!selectUnit.sub" class="row align-items-center" >
              <van-field class="text-center flex-1 fs1"
                @input="onSizeInput(sub)"
                v-model="sub.weightCode" placeholder="请输入" />
              <!-- <a @click="cancelCustom(index)" class="fs1 pt3 pb3 pl3 fc-light">取消</a> -->
            </div>
            <div v-else  @click="showSizePickerFunc(sub.categoryCode)">
              {{sub.weightText||''}}
              <span class="fc-suppl" v-if="!sub.weightText">选择规格</span>
            </div>
          </td>
          <td>
            <!-- 价格 -->
            <div style="min-width: 145px;">
              <van-stepper v-model="sub.price" :button-size="30" :default-value="0"
              :step="0.5" :min="mapping[quoteType].min" :max="mapping[quoteType].max" :input-width="60" />
            </div>
          </td>
          <td><a @click="resetRow(index)" class="fc-danger fs4">取消</a></td>
        </tr>
        <tr>
          <td colspan="4">
            <div class="row justify-content-around pl7 pr7">
              <van-button v-if="sortDataList.length>1" @click="showPopup" plain class="btn-common" type="info">调整报价顺序</van-button>
              <van-button @click="addLine" plain class="btn-common" type="info"><van-icon name="plus"/> 增加一栏</van-button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div v-if="templateType!=3" class="row align-items-center pb4 fs4 small-categories pr2 text-left">
      <div class="pl3 pr3 btn-label">主营范围</div>
      <div class="col fs2 row align-items-center">
        <van-field class="flex-1"
          v-model="params.mainProducts" placeholder="主营范围" />
      </div>
    </div>
    <div class="row align-items-center pb4 fs4 small-categories pr2 text-left">
      <div class="pl3 pr3 btn-label">联系方式</div>
      <div class="flex-1 text-left">
        <div class="row align-items-center pt1 pb1"
          v-for="(mo, index) in mobileList"
          :key="index">
          <div class="col-8">
            <van-field
              label-width="70px"
              v-model="mo.name"
              clearable
              placeholder="称呼"
            />
          </div>
          <div class="flex-1 pl2">
            <van-field
              label-width="70px"
              v-model="mo.mobile"
              clearable
              placeholder="电话号码"
            />
          </div>
          <van-icon v-if="index + 1 === mobileList.length"
            @click="addMobile" name="add-o" size="20px"/>
          <van-icon v-else
              @click="removeMobile(index)" name="close" class="fc-danger" size="20px"/>
        </div>
      </div>
    </div>
    <div class="row align-items-center pb4 fs4 small-categories pr2 text-left">
      <div class="pl3 pr3 btn-label">联系地址</div>
      <div class="col fs2 row align-items-center">
        <van-field class="flex-1"
          v-model="params.address" placeholder="联系地址" />
      </div>
    </div>
    <div class="row align-items-center pb4 fs4 small-categories pr2 text-left">
      <div class="pl3 pr3 btn-label">备注</div>
      <div class="col fs2 row align-items-center">
        <van-field class="flex-1"
          v-model="params.describe" placeholder="备注" />
      </div>
    </div>
    <div class="row align-items-center pb4 fs4 small-categories pr2 text-left">
      <div class="pl3 pr3 btn-label">微信名片</div>
      <div class="col fs2 row align-items-center">
        <van-uploader
          :disabled="uploadLoading"
          @click.native="clickUpload(-1)"
          class="col"
          width="100%"
          height="105"
          v-model="fileList"
          multiple
          :max-count="1"
          :after-read="afterRead"
          :preview-full-image="false"
          image-fit="cover"
          @delete="deleteImage(-1)"
        />
      </div>
    </div>
    <div class="row justify-content-around mt10 pl7 pr7">
      <van-button @click="back" type="info" class="btn-common plain" plain>返回</van-button>
      <van-button @click="goPoster" type="info" class="btn-common">生成报价单</van-button>
    </div>
    <div v-if="loading" class="fc-suppl text-center pt10">
      加载中...
    </div>
    <van-popup v-model="showUnitPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="units"
        @cancel="showUnitPicker = false"
        @confirm="onConfirmUnit"
      />
    </van-popup>
    <van-popup v-if="selectUnit.value" v-model="showCatePicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="categoriesOrigin"
        @cancel="showCatePicker = false"
        @confirm="onConfirmCate"
      />
    </van-popup>
    <van-popup v-if="selectUnit.value" v-model="showSizePicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="selectUnit.sub"
        @cancel="showSizePicker = false"
        @confirm="onConfirm"
      />
    </van-popup>
    <van-popup v-model="showInfo1Picker" position="bottom">
      <van-picker
        show-toolbar
        :columns="info1"
        @cancel="showInfo1Picker = false"
        @confirm="onInfo1Confirm"
      />
    </van-popup>
    <van-popup v-model="showInfo2Picker" position="bottom">
      <van-picker
        show-toolbar
        :columns="info2"
        @cancel="showInfo2Picker = false"
        @confirm="onInfo2Confirm"
      />
    </van-popup>
    <van-popup v-model="showPriceTypePicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="types"
        @cancel="showPriceTypePicker = false"
        @confirm="onPriceTypeConfirm"
      />
    </van-popup>
    <van-popup v-model="showDate" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        title="选择年月日"
        @confirm="confirmDate"
        @cancel="showDate = false"
      />
    </van-popup>
    <van-popup
      v-model="popupShow"
      position="bottom"
      :style="{ height: '100%' }"
    >
      <h4>调整报价顺序</h4>
      <div class="pl5 pb7 pr5">
        <div class="sort-box">
          <template v-for="(info, popupDataIndex) in popupDataList" >
            <div class="row align-items-center pt3 pb3 pl5 pr5" :key="popupDataIndex">
              <div class="flex-1 text-left">{{info.text||info.customValue}}</div>
              <div class="col-6"><van-button v-if="popupDataIndex>0"
                @click="goUp(popupDataIndex)" type="info" plain size="small" class="pl5">点我向上&#x2b06;</van-button></div>
              <div class="col-6"><van-button v-if="popupDataIndex+1<popupDataList.length" @click="goDown(popupDataIndex)" type="info" plain size="small" class="pl5">点我向下&#x2b07;</van-button></div>
            </div>
            <div class="line" :key="'line'+popupDataIndex"></div>
          </template>
        </div>
        <div class="row justify-content-around mt10">
          <van-button @click="closePopup" type="info" class="btn-common" plain>暂不调整</van-button>
          <van-button @click="saveSort" type="info" class="btn-common">保存顺序</van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue';
// import draggable from 'vuedraggable';
import storage from '../../uitls/cacheUtil';
import config from '../../config';
import {
  sendRequest, quoteDict, uploadFile, upload,
} from '../../network/NetworkAccessor';

let categoryCode = '';
let categoryIndex = -1;
let originLastData = null;

export default Vue.extend({
  name: 'QuotationPosterEdit',
  // components: { draggable },
  data() {
    return {
      fileDomain: config.FILE_DOMAIN,
      dragOptions: {
        handle: '.my-handle',
        animation: 150,
      },
      quoteTypes: [
        {
          name: 1,
          title: '龙虾报价',
        },
        {
          name: 2,
          title: '螃蟹报价',
        },
      ],
      mapping: {
        // 龙虾价格可填写限制3-100元，螃蟹价格可填写限制在4-200元
        1: {
          label1: '行话',
          label2: '规格',
          min: 3,
          max: 100,
        },
        2: {
          label1: '规格',
          label2: '实际重量',
          min: 4,
          max: 200,
        },
      },
      loading: false,
      categories: [],
      categoriesOrigin: [],
      units: [],
      selectUnit: {},
      showUnitPicker: false,
      showSizePicker: false,
      showCatePicker: false,
      quotation: [],
      crabLimit: 1,
      crayfishLimit: 1,
      quoteType: 1, // 1--龙虾 2--螃蟹
      crab: {},
      crayfish: {},
      info1: [],
      freight: {},
      info2: [],
      death: {},
      showInfo1Picker: false,
      showInfo2Picker: false,
      priceType: {},
      priceTypeStr: '',
      showPriceTypePicker: false,
      types: [],
      popupShow: false,
      popupDataList: [],
      params: {
      },
      currentDate: new Date(),
      showDate: false,
      mobileList: [{}],
      fileList: [],
      uploadLoading: false,
    };
  },
  props: {
    templateType: {
      type: String,
      default: '',
    },
  },
  computed: {
    sortDataList() {
      return this.categories.filter(l => l.text || l.customValue);
    },
  },
  methods: {
    formatFileList() {
      if (this.params.qrcodeUrl) {
        this.fileList = [{
          url: this.params.qrcodeUrl,
          isImage: true,
        }];
        return;
      }
      this.fileList = [];
    },
    deleteImage(index) {
      this.uploadIndex = index;
      console.log(index);
      if (this.uploadIndex > -1) {
        this.$set(this.priceSourceList[this.uploadIndex], 'list', []);
      } else {
        this.$set(this.params, 'qrcodeUrl', '');
        // this.$set(this.params, 'qrcodeFile', '');
      }
    },
    clickUpload(index) {
      console.log(index);
      this.uploadIndex = index;
    },
    afterRead(file) {
      console.log(file);
      // 此时可以自行将文件上传至服务器
      // this.uploadSource(file.file);
      this.$set(this.params, 'qrcodeUrl', file.content);
      // this.$set(this.params, 'qrcodeFile', file.file);
    },
    uploadSource(file) {
      this.uploadLoading = true;
      const params = new FormData();
      params.append('file', file);
      upload(uploadFile, params).then((url = '') => {
        this.$set(this.params, 'qrcodeUrl', url);
        // this.$set(this.params, 'qrcodeFile', '');
        this.formatFileList();
      }).catch((e) => {
        this.$set(this.params, 'qrcodeUrl', '');
        // this.$set(this.params, 'qrcodeFile', '');
        this.fileList = [];
        this.$dialog.alert({
          message: e.message,
        });
      }).then(() => {
        this.uploadLoading = false;
      });
    },
    addMobile() {
      this.mobileList.push({
        mobile: '',
        name: '',
      });
    },
    removeMobile(index) {
      this.mobileList.splice(index, 1);
    },
    showDateAction(type = '') {
      this.showDate = true;
      this.clickPicker = type;
    },
    confirmDate(val) {
      console.log(val);
      // const [province = {}] = val;
      let date = {};
      if (val) {
        date = this.formatDate(val);
      }
      this.$set(this.params, 'queryDate', date.value || '');
      this.$set(this.params, 'queryDateText', date.text || '');
      this.showDate = false;
      this.clickPicker = '';
    },
    formatDate(date, hasTime = false) {
      if (!date) {
        return {};
      }
      const month = date.getMonth() + 1;
      const monthStr = month > 9 ? month : `0${month}`;
      const d = date.getDate();
      const dStr = d > 9 ? d : `0${d}`;
      const datestr = `${date.getFullYear()}${monthStr}${dStr}`;
      const text = `${date.getFullYear()}-${month}-${d}`;
      if (hasTime) {
        return {
          text: `${text} ${date.getHours()}:${date.getMinutes()}`,
        };
      }
      // console.log(datestr);
      return {
        value: datestr,
        text,
      };
    },
    changeBigCate(type = 1) {
      // this.getLastData();
      this.quoteType = type;
      // 加载对应品类的历史数据，保留通用信息
      this.loadCategoryData(true);
      this.handleDict();
    },
    // 获取上次报价信息
    getDict() {
      // console.log(this.units);
      return sendRequest(quoteDict).then((res = {}) => {
        const { crab = {}, crayfish = {} } = res;
        this.crab = crab;
        this.crayfish = crayfish;
        return res;
      }).catch((e) => {
        console.error(e);
      });
    },
    goPoster() {
      if (!this.selectUnit.value) {
        this.$dialog.alert({
          message: '请先选择重量单位',

        });
        return;
      }
      const quotes = this.categories.map((c) => {
        if (c.isCustom) {
          // eslint-disable-next-line no-param-reassign
          c.categoryText = c.customValue;
          // eslint-disable-next-line no-param-reassign
          c.categoryCode = c.customValue;
        }
        if (c.weightCustom || !this.selectUnit.sub) {
          // eslint-disable-next-line no-param-reassign
          c.weightText = c.weightCode;
        }
        // eslint-disable-next-line no-param-reassign
        c.tPrice = c.price;
        return c;
      });

      // 处理销售日期：未填写时，晚上7点后显示第二天日期
      let { queryDateText, queryDate } = this.params;
      if (!queryDateText) {
        let targetDate = new Date();
        // 晚上7点(19:00)以后，显示第二天的日期
        if (targetDate.getHours() >= 19) {
          targetDate = new Date(targetDate.getTime() + 1000 * 60 * 60 * 24);
        }
        const dateInfo = this.formatDate(targetDate);
        queryDateText = dateInfo.text;
        queryDate = dateInfo.value;
      }

      const posterData = Object.assign({}, {
        unitText: this.selectUnit.text,
        unitCode: this.selectUnit.value,
        selectUnit: this.selectUnit,
        quotes,
        // // 运费
        // info1: this.freight.isCustom ? this.freight.value : this.freight.text,
        // freight: this.freight,
        // // 死亡
        // info2: this.death.isCustom ? this.death.value : this.death.text,
        // death: this.death,
        quoteType: this.quoteType,
        priceType: this.priceType.text,
        priceTypeObj: this.priceType,
        mobileList: this.mobileList,
        createDate: this.formatDate(new Date(), true).text,
        queryDateText,
        queryDate,
      }, this.params);

      // 使用localStorage按品类分别存储
      storage.local.set(`POSTER_DATA_${this.quoteType}`, posterData);

      // 同步通用信息到另一个品类（保持通用信息一致）
      const otherQuoteType = this.quoteType === 1 ? 2 : 1;
      const otherData = storage.local.get(`POSTER_DATA_${otherQuoteType}`) || {};
      storage.local.set(`POSTER_DATA_${otherQuoteType}`, {
        ...otherData,
        name: this.params.name,
        customer: this.params.customer,
        mainProducts: this.params.mainProducts,
        qrcodeUrl: this.params.qrcodeUrl,
        address: this.params.address,
        describe: this.params.describe,
        mobileList: this.mobileList,
      });

      // 同时存储到session供展示页面使用
      storage.session.set('POSTER_DATA', posterData);
      this.$router.push({
        name: 'QuotationPosterTool',
        params: {
          templateType: `${this.templateType}`,
        },
      });
    },
    checkSize(e, weightCode) {
      const data = JSON.parse(originLastData) || [];
      const find = data.find(d => e === d.value
        && d.price
        && d.weightCode);
      return Promise.resolve().then(() => {
        if (find && !find.note) {
          return this.$dialog.confirm({
            title: '确认',
            message: `确认更改${find.text}的规格/实际重量吗？`,
          }).then(() => {
            find.note = true;
            originLastData = JSON.stringify(data);
            return false;
          }).catch(() => find);
        }
        return false;
      });
    },
    showSizePickerFunc(e) {
      this.checkSize(e).then((res) => {
        if (!res) {
          this.showSizePicker = true;
          categoryCode = e;
          console.log(categoryCode);
        }
      });
    },
    showCatePickerFunc(e) {
      this.showCatePicker = true;
      categoryIndex = e;
      console.log(e);
    },
    onSizeInput(e) {
      this.checkSize(e.value, e.weightCode).then((res) => {
        if (res) {
          this.$set(e, 'weightCode', res.weightCode);
        }
      });
      // console.log(this.categoriesOrigin);
    },
    onCateInput(e) {
    },
    onConfirmUnit(e) {
      console.log(e);
      this.selectUnit = e || {};
      this.showUnitPicker = false;
    },
    onConfirmCate(e) {
      this.showCatePicker = false;
      const findIndex = categoryIndex;
      if (e.isCustom) {
        this.$set(this.categories[findIndex], 'isCustom', true);
        this.$set(this.categories[findIndex], 'categoryText', '');
        return;
      }
      const same = this.categories.find(c => c.categoryCode === e.value);
      if (same) {
        this.$dialog.alert({
          message: `${same.categoryText || same.customValue}已存在，不可以重复添加`,
        });
        return;
      }
      this.$set(this.categories[findIndex], 'categoryText', e.text);
      this.$set(this.categories[findIndex], 'categoryCode', e.value);
    },
    onConfirm(e) {
      console.log(e);
      this.showSizePicker = false;
      const findIndex = this.categories.findIndex(q => q.categoryCode === categoryCode);
      console.log(findIndex, categoryCode);
      this.$set(this.categories[findIndex], 'weightCode', e.value);
      this.$set(this.categories[findIndex], 'weightText', e.text);
      if (e.isCustom) {
        this.$set(this.categories[findIndex], 'weightCustom', true);
      } else {
        this.$set(this.categories[findIndex], 'weightCustom', false);
      }
    },
    onBlur(e) {
      console.log(e);
      // 龙虾价格可填写限制3-100元，螃蟹价格可填写限制在4-200元
      const { min } = this.mapping[this.quoteType];
      const { max } = this.mapping[this.quoteType];
      if (e.price !== '' && e.price !== undefined && (Number.isNaN(e.price) || e.price > max || e.price < min)) {
        this.$dialog.alert({
          message: `${this.quoteType === 1 ? '龙虾' : '螃蟹'}价格只能填写${min}～${max}之间的数字`,
        });
        this.$set(e, 'price', this.mapping[this.quoteType].min);
      }
      // console.log(this.categories);
    },
    addLine() {
      if (!this.selectUnit.value) {
        this.$dialog.alert({
          message: '请先选择重量单位',
        });
        return;
      }
      this.categories.push({
        categoryText: '',
        categoryCode: `custom${this.categories.length}`,
        price: this.mapping[this.quoteType].min,
      });
    },
    customCate() {
      this.categories.push({
        categoryText: '',
        categoryCode: `custom${this.categories.length}`,
        isCustom: true,
      });
    },
    cancelCustom(index) {
      this.$set(this.categories[index], 'weightCustom', false);
      this.$set(this.categories[index], 'weightCode', '');
      this.$set(this.categories[index], 'weightText', '');
      // this.categories.push({
      //   text: '',
      //   value: '',
      //   isCustom: true,
      // });
    },
    resetCustom(item, key1, key2, key3) {
      this.$set(item, key1, '');
      this.$set(item, key2, '');
      this.$set(item, key3, false);
    },
    resetRow(index) {
      if (this.categories.length < 2) {
        this.categories = [{ categoryText: '', categoryCode: '' }];
        return;
      }
      this.categories.splice(index, 1);
    },
    changeUnit() {
      console.log('-----');
      this.showUnitPicker = true;
      // this.categories = this.categories.map(e => {
      //   e.weightCode = '';
      //   e.weightText = '';
      //   return e;
      // });
    },
    showPriceTypePickerFunc() {
      this.showPriceTypePicker = true;
    },
    showInfo1PickerFunc() {
      this.showInfo1Picker = true;
    },
    showInfo2PickerFunc() {
      this.showInfo2Picker = true;
    },
    onInfo1Confirm(e) {
      this.freight = e || {};
      this.showInfo1Picker = false;
    },
    onInfo2Confirm(e) {
      console.log(e);
      this.death = e || {};
      this.showInfo2Picker = false;
    },
    onPriceTypeConfirm(e) {
      console.log(e);
      this.priceType = e || {};
      this.showPriceTypePicker = false;
    },
    cancelInfo1Custom() {
      this.freight = {};
    },
    cancelPriceTypeCustom() {
      this.priceType = {};
    },
    cancelInfo2Custom() {
      this.death = {};
    },
    logout() {
      storage.local.set('token', '');
      storage.local.set('type', '');
      this.$router.push('/login');
    },
    back() {
      this.$router.replace('/quotation/template');
    },
    showPopup() {
      this.popupShow = true;
      this.popupDataList = JSON.parse(JSON.stringify(this.sortDataList));
    },
    closePopup() {
      this.popupShow = false;
    },
    saveSort() {
      this.categories = JSON.parse(JSON.stringify(this.popupDataList));
      this.closePopup();
    },
    goUp(popupDataIndex) {
      if (!popupDataIndex) {
        return;
      }
      const current = this.popupDataList.splice(popupDataIndex, 1);
      this.popupDataList.splice(popupDataIndex - 1, 0, current[0]);
    },
    goDown(popupDataIndex) {
      if ((!popupDataIndex && popupDataIndex !== 0) || popupDataIndex + 1 >= this.popupDataList.length) {
        return;
      }
      const current = this.popupDataList.splice(popupDataIndex, 1);
      this.popupDataList.splice(popupDataIndex + 1, 0, current[0]);
    },
    handleDict() {
      const data = JSON.parse(JSON.stringify(this.quoteType === 1 ? this.crayfish : this.crab));
      this.categoriesOrigin = JSON.parse(JSON.stringify(data.categories || []));
      this.categoriesOrigin.push(
        {
          value: '',
          text: '自定义填写',
          isCustom: true,
        },
      );
      this.info1 = data.info1 || [];
      this.info2 = data.info2 || [];
      this.info1.push({
        value: '',
        text: '自定义填写',
        isCustom: true,
      });
      this.info2.push({
        value: '',
        text: '自定义填写',
        isCustom: true,
      });
      this.units = (data.units || []).map((u) => {
        if (u.sub) {
          u.sub.push({
            value: '',
            text: '自定义填写',
            isCustom: true,
          });
        }
        return u;
      });
    },
    loadCategoryData(preserveCommon = false) {
      // 根据当前品类从localStorage加载对应的历史数据
      const obj = storage.local.get(`POSTER_DATA_${this.quoteType}`) || {};
      const currentParams = this.params || {};

      // 通用信息：档口名称、客户名称、联系方式、地址等
      // 品类特定信息：重量单位、报价明细、价格类型
      if (preserveCommon) {
        // 切换品类时，保留通用信息，只加载品类特定数据
        this.priceType = obj.priceTypeObj || {};
        this.death = obj.death || {};
        this.freight = obj.freight || {};
        this.categories = obj.quotes || [];
        this.selectUnit = obj.selectUnit || {};
      } else {
        // 初始加载时，全部从localStorage读取
        this.params = {
          name: obj.name || currentParams.name || '',
          customer: obj.customer || currentParams.customer || '',
          queryDateText: obj.queryDateText || currentParams.queryDateText || '',
          queryDate: obj.queryDate || currentParams.queryDate || '',
          mainProducts: obj.mainProducts || currentParams.mainProducts || '',
          qrcodeUrl: obj.qrcodeUrl || currentParams.qrcodeUrl || '',
          address: obj.address || currentParams.address || '',
          describe: obj.describe || currentParams.describe || '',
        };
        this.mobileList = obj.mobileList || [{}];
        this.priceType = obj.priceTypeObj || {};
        this.death = obj.death || {};
        this.freight = obj.freight || {};
        this.categories = obj.quotes || [];
        this.selectUnit = obj.selectUnit || {};
        this.formatFileList();
      }
    },
    initData() {
      // 初始化时也使用localStorage加载对应品类的数据
      this.loadCategoryData();
    },
  },
  created() {
    this.initData();

    originLastData = null;
    this.loading = true;
    const pros = [];
    pros.push(this.getDict());
    Promise.all(pros).then((res) => {
      console.log(res);
      const { priceType = '' } = res[0];
      priceType.push({
        value: '',
        text: '自定义填写',
        isCustom: true,
      });
      this.types = priceType;
      this.handleDict();
      this.loading = false;
    }).catch(() => {
      this.loading = false;
    });
  },
});
</script>
<style scoped>
  .QuotationEdit {
    min-height: 100vh;
    background-color: #ffffff;
    font-size: 17px;
    padding-left: 2px;
    padding-right: 2px;

  }
  .QuotationEdit .fixed-tab {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    background-color: white;
    z-index: 999;
    padding: 0;
    overflow: hidden;
  }
  .van-tabs--card {
    padding-top: 0;
  }
  .fixed-tab >>> .van-tabs__nav--card  {
    margin: 0;
    border-radius: 0;
    height: 50px;
  }
  .fixed-tab >>> .van-tab  {
    padding: 15px 0;
  }
  .tab-holder {
    height: 50px;
  }
  .add-box {
    /* padding: 10px 15px; */
  }
  .add {
    padding: 5px 15px;
  }
  .btn-label {
    width: 95px;
  }
  .QuotationEdit .table-quotation {
    margin-top: 15px;
    width: 100%;
    border-spacing: 0;
    border-radius: 4px;
    border: 1px solid #a7a9af;
    /* border-top: 1px solid #a7a9af;
    border-left: 1px solid #a7a9af;
    border-right: 1px solid #a7a9af; */
  }
  .table-quotation th {
    /* background-color: #a7a9af; */
    /* color: #1e67c7; */
    padding: 6px 0;
    border-bottom: 1px solid #a7a9af;
  }
  .table-quotation td {
    padding: 6px 2px;
    /* border-bottom: 1px solid #1e67c7; */
  }
  .table-quotation >>> .van-field__right-icon {
    padding: 2px;
    padding-right: 8px;
  }
  .table-quotation >>> .van-field__right-icon .van-icon {
    font-size: 18px;
  }
</style>
